import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import rehydrate from './rehydrate';
import auth from './auth';
import request from './request';
import requestsForAccounting from './requests-accounting';
import travelExpense from './travelExpense';
import requestsForManager from './requests-manager';
import requestsForHr from './requests-hr';
import holidays from './holidays';
import exchangeRate from './exchangeRate';
import lastDayOfMonth from './lastDayOfMonth';
import reports from './reports';
import pdfDownload from './pdfDownload';

export default combineReducers({
  routing: routerReducer,
  rehydrate,
  auth,
  request,
  requestsForManager,
  requestsForAccounting,
  requestsForHr,
  travelExpense,
  holidays,
  exchangeRate,
  lastDayOfMonth,
  reports,
  pdfDownload
});



// WEBPACK FOOTER //
// ./src/redux/modules/index.js